import bookEmpty from '../assets/images/book_empty.png';

type EmptyStateProps = {
  text: string;
};

export const EmptyState = ({ text }: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center">
      <img src={bookEmpty} alt="Empty State" className="w-48 sm:w-96" />
      <h1 className="text-xl md:text-4xl text-center font-semibold text-cyan-800">{text}</h1>
    </div>
  );
};
